






























































































































import { Component } from 'vue-property-decorator';
import AccountApi from '@web/services/AccountService';
import LayoutAbstract from '@shared/views/LoginLayouts/Layout.abstract';
import RouterHelper from '@shared/helpers/router.helper';
import {
  studentLoginModel,
  studentLoginFields,
  studentLoginFieldsValidation,
  loginModel,
  loginFields,
  loginFieldsValidation,
} from '@shared/models/LoginModels';
import { EModes } from '@shared/models/Enums/EModes';
import { parseErrors } from '@shared/helpers/common.helper';
import { ServerErrorsModel } from '@shared/models/Common/ServerErrorsModel';
import { EUserRoles } from '@/shared/src/models/Enums';
import * as bowser from 'bowser';

const api = new AccountApi();
const routerHelper = new RouterHelper();

@Component<LayoutAbstract>({})
export default class Login extends LayoutAbstract {
  public showPass = false;

  validations: any = {
    model: loginFieldsValidation,
  };

  public isStudent = false;

  public fields = loginFields;

  public model: any = { ...loginModel };

  public loading = false;

  public serverErrors: string[] = [];

  // private showOverlay = false;

  // get isSafari(): boolean {
  //   const { name } = bowser.getParser(window.navigator.userAgent).getBrowser();
  //   return (name?.toLowerCase() || '') === 'safari';
  // }

  accountIsUsing = false;

  showFullAlert = false;

  private config = {
    [EModes[EModes.Parents]]: {
      model: loginModel,
      fields: loginFields,
      validations: loginFieldsValidation,
    },
    [EModes[EModes.Students]]: {
      model: studentLoginModel,
      fields: studentLoginFields,
      validations: studentLoginFieldsValidation,
    },
  };

  updateForm() {
    const { model, fields, validations } = this.config[EModes[this.mode]];
    this.model = { ...model };
    this.fields = fields;
    this.validations = {
      model: validations,
    };
  }

  setMode(mode: number) {
    this.$v.model.$reset();
    this.mode = mode;
    this.updateForm();
  }

  async logIn() {
    this.$v.model.$touch();

    if (this.isFormInvalid) return;
    this.loading = true;
    this.accountIsUsing = false;
    this.showFullAlert = false;

    let request = Promise.resolve();
    this.serverErrors = [];
    if (this.mode === EModes.Students) {
      request = api.accountStudyLogin(this.model /* , this.isSafari */);
    } else if (this.mode === EModes.Parents) {
      request = api.accountOrganizationAndParentLogin(this.model);
    }

    request
      .catch((error: any): any => {
        // if (error.message === 'Is safari') {
        //   this.showOverlay = true;
        // }
        const errors = parseErrors(
          error.response.data.errors as ServerErrorsModel
        );

        if (
          errors.length === 1 &&
          errors[0].includes('Account already in use')
        ) {
          return api
            .getUserRole({ userName: this.model.userName })
            .then((res: any) => {
              console.log(res);
              if (
                res.data.role === EUserRoles.ORGANIZATION_STUDENT ||
                res.data.role === EUserRoles.CHILD
              ) {
                this.isStudent =
                  res.data.role === EUserRoles.ORGANIZATION_STUDENT;
                this.accountIsUsing = true;
              }
            });
        }
        if (errors[0].includes('is expired')) {
          return this.$router.push({
            path: routerHelper.expired().getRoute(),
            query: {
              plan: errors[0].includes('trial') ? 'trial' : 'annual',
            },
          });
        }
        this.serverErrors = errors;
        return false;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
